import Component, { mixins } from 'vue-class-component'
import { Ref, Watch } from 'vue-property-decorator'

import WithRender from './FicheRepondantCreate.html'

import {
  MButton,
  MButtonSkin,
  MDialog,
  MDialogState,
  MDialogWidth,
  MMessage,
  MMessageSkin,
  MMessageState,
  MSpinner
} from '@ulaval/modul-components'

import FicheRepondantAvailableCasSpecial from '../form/FicheRepondantAvailableCasSpecial'
import FicheRepondantForm, { IFicheRepondantFormPayload } from '../form/FicheRepondantForm'
import FicheRepondantConditionsOverlay from '../FicheRepondantConditionsOverlay'
import FicheRepondantService from '../FicheRepondant.service'
import { ICasSpecialRepondant } from '../CasSpecialRepondant.model'
import EventBus from '@/EventBus'
import { FicheRepondantAvailableCasSpecialRow_EVENTS, IFicheRepondantAvailableCasSpecialRowItemSelectedEventPayload } from '../form/FicheRepondantAvailableCasSpecialRow'
import CountryService from '@/modules/global/localization/country/Country.service'
import ROUTES from '@/router/ROUTES'

const REF_FICHE_REPONDANT_FORM: string = 'ref[fiche-repondant-form]'

@WithRender
@Component({
  components: {
    FicheRepondantAvailableCasSpecial,
    FicheRepondantConditionsOverlay,
    FicheRepondantForm,
    MButton,
    MDialog,
    MMessage,
    MSpinner
  }
})
export default class FicheRepondantCreate extends mixins(FicheRepondantService, CountryService) {
  private casSpeciauxDisponible: Array<ICasSpecialRepondant> = []
  private isLoadingStateActive: boolean = false
  private isSuccessStateActive: boolean = false
  private isSubmitDialogOpen: boolean = false
  private selectedCasSpecialIds: Array<number> = []

  private readonly MButtonSkin: object = MButtonSkin
  private readonly MMessageSkin: object = MMessageSkin
  private readonly MMessageState: object = MMessageState
  private readonly MDialogState: object = MDialogState
  private readonly MDialogWidth: object = MDialogWidth
  private readonly REF_FICHE_REPONDANT_FORM: string = REF_FICHE_REPONDANT_FORM

  @Ref(REF_FICHE_REPONDANT_FORM)
  private ficheRepondantFormComponent!: FicheRepondantForm | null

  @Watch('$route.query', { immediate: true })
  private onRouteQueryChange(): void {
    this.loadCasSpeciauxDisponible()
  }

  private get isFormDisplayed(): boolean {
    return this.selectedCasSpecialIds.length > 0
  }

  private mounted(): void {
    this.afterFicheRepondantAvailableCasSpecialRowItemSelected()
    this.loadCountries()
  }

  private loadCasSpeciauxDisponible(): void {
    this.service_ficheRepondantService_fetchAvailableCasSpecial(this.$route.query['code-session'] as string)
      .then((response: Array<ICasSpecialRepondant>) => {
        this.casSpeciauxDisponible = response || []
      })
  }

  private loadCountries(): void {
    this.service_countryService_fetchCountries()
  }

  private afterFicheRepondantAvailableCasSpecialRowItemSelected(): void {
    EventBus.$on(FicheRepondantAvailableCasSpecialRow_EVENTS.ITEM_SELECTED, (payload: IFicheRepondantAvailableCasSpecialRowItemSelectedEventPayload) => {
      const selectedCasSpecialIndex: number | undefined = this.selectedCasSpecialIds.indexOf(payload.casSpecial.id)

      if (payload.isSelected) {
        if (!~selectedCasSpecialIndex) {
          this.$set(this.selectedCasSpecialIds, this.selectedCasSpecialIds.length, payload.casSpecial.id)
        }
      } else if (~selectedCasSpecialIndex) {
        this.$delete(this.selectedCasSpecialIds, selectedCasSpecialIndex)
      }
    })
  }

  private async onSubmitButtonClick(): Promise<void> {
    if (this.ficheRepondantFormComponent) {
      const formPayload: IFicheRepondantFormPayload | null = await this.ficheRepondantFormComponent.getFormPayload()
      
      if (formPayload) {
        this.displaySubmitDialog()
      }
    }
  }

  private async onDialogSubmitButtonClick(): Promise<void> {
    if (this.ficheRepondantFormComponent) {
      const formPayload: IFicheRepondantFormPayload | null = await this.ficheRepondantFormComponent.getFormPayload()
      
      if (formPayload) {
        this.createFicheRepondant(formPayload)
      }
    }
  }

  private createFicheRepondant(formPayload: IFicheRepondantFormPayload): void {
    this.isSubmitDialogOpen = false
    this.hideSubmitDialog()

    this.service_ficheRepondantService_create(
      formPayload,
      this.$route.query['code-session'] as string,
      this.selectedCasSpecialIds
    ).then(() => {
      this.isSuccessStateActive = true
    }).finally(() => {
      this.isLoadingStateActive = false
    })
  }

  private onReturnHomeButtonClick(): void {
    this.mixin_router_navigate({
      name: ROUTES.FICHE_REPONDANT_OVERVIEW,
      params: this.$route.params,
      query: this.$route.query
    })
  }

  private displaySubmitDialog(): void {
    this.isSubmitDialogOpen = true
  }

  private hideSubmitDialog(): void {
    this.isSubmitDialogOpen = false
  }
}
